import { useState, useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import Breadcrumb from '../../../core/common/Breadcrumb/breadcrumb'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { Link } from 'react-router-dom'
import StudentSidebar from '../common/studentSidebar'
import ProfileCard from '../common/profileCard'
import { all_routes } from '../../router/all_routes'
import { calculateDiscount, rupiahFormatter } from '../../../utils/helpers'
import { getPurchasedCourses } from '../../../api/user'

// Course card component
const CourseCard = ({ course, selectedItems, handleItemClick, type }: any) => {
  // Countdown state for live teaching
  const [countdown, setCountdown] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  })

  // Countdown effect for live teaching
  useEffect(() => {
    if (type === 'live' && course.start_date && course.end_date) {
      const timer = setInterval(() => {
        const now = new Date().getTime()
        const startDate = new Date(course.start_date).getTime()
        const timeLeft = startDate - now

        if (timeLeft > 0) {
          const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24))
          const hours = Math.floor(
            (timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
          )
          const minutes = Math.floor(
            (timeLeft % (1000 * 60 * 60)) / (1000 * 60),
          )
          const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000)

          setCountdown({ days, hours, minutes, seconds })
        } else {
          setCountdown({ days: 0, hours: 0, minutes: 0, seconds: 0 })
        }
      }, 1000)

      return () => clearInterval(timer)
    }
  }, [course.start_date, course.end_date, type])

  return (
    <div className="col-xl-4 col-md-6">
      <div
        className="course-item-two course-item mx-0"
        style={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div className="course-img">
          <Link
            to={
              type === 'live'
                ? all_routes.studentLiveEventDetails.replace(
                    ':id',
                    course.id.toString(),
                  )
                : type === 'course'
                ? all_routes.studentCourseContent.replace(
                    ':id',
                    course.id.toString(),
                  )
                : type === 'cbt'
                ? all_routes.jadiUkomDetail.replace(':id', course.id.toString())
                : all_routes.courseDetails
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            <ImageWithBasePath
              src={''}
              srcApi={course.image || '/assets/img/course/course-48.jpg'}
              fallbackSrc="/assets/img/course/course-48.jpg"
              alt={course.title}
              className="img-fluid"
              isLandscape={true}
            />
          </Link>
          <div className="position-absolute start-0 top-0 d-flex align-items-start w-100 z-index-2 p-3">
            {course.discount && course.discount !== '0.00' && (
              <div className="badge text-bg-danger">
                {course.discount_type === 'PERCENTAGE'
                  ? `${course.discount}% off`
                  : `${rupiahFormatter(parseFloat(course.discount))} off`}
              </div>
            )}
            <Link
              to="#"
              className={`fav-icon ms-auto ${
                selectedItems[course.id] ? 'selected' : ''
              }`}
              onClick={() => handleItemClick(course.id)}
            >
              <i className="isax isax-heart" />
            </Link>
          </div>
        </div>
        <div
          className="course-content"
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="d-flex align-items-center">
              {course.start_date && course.end_date && type === 'live' && (
                <>
                  {(() => {
                    const now = new Date().getTime()
                    const startDate = new Date(course.start_date).getTime()
                    const endDate = new Date(course.end_date).getTime()

                    if (now > endDate) {
                      return (
                        <span className="badge mb-0 bg-info">
                          Event Selesai
                        </span>
                      )
                    }

                    if (now >= startDate && now <= endDate) {
                      return (
                        <span className="badge mb-0 bg-success">Live Now</span>
                      )
                    }

                    if (now < startDate) {
                      // Tampilkan format yang berbeda berdasarkan jumlah hari
                      let countdownText = ''
                      if (countdown.days > 0) {
                        countdownText = `${
                          countdown.days
                        } hari ${countdown.hours
                          .toString()
                          .padStart(
                            2,
                            '0',
                          )} : ${countdown.minutes
                          .toString()
                          .padStart(
                            2,
                            '0',
                          )} : ${countdown.seconds.toString().padStart(2, '0')}`
                      } else {
                        countdownText = `${countdown.hours
                          .toString()
                          .padStart(
                            2,
                            '0',
                          )} : ${countdown.minutes
                          .toString()
                          .padStart(
                            2,
                            '0',
                          )} : ${countdown.seconds.toString().padStart(2, '0')}`
                      }

                      return (
                        <span className="badge mb-0 bg-warning">
                          {countdownText}
                        </span>
                      )
                    }
                  })()}
                </>
              )}
              {type === 'course' && (
                <>
                  <span className="badge mb-0 bg-info">
                    {`${course.student_count || 0} Siswa`}
                  </span>
                </>
              )}
              {type === 'cbt' && (
                <>
                  <span className="badge mb-0 bg-info">
                    {`${course.questions_count || 0} Soal`}
                  </span>
                </>
              )}
            </div>
            <span className="badge badge-light rounded-pill bg-light d-inline-flex align-items-center fs-13 fw-medium mb-0">
              {course.course_level}
            </span>
          </div>
          <h6
            className="title mb-2"
            style={{
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              lineHeight: '1.4',
              minHeight: '2.8em', // 2 baris x 1.4 line-height
              maxHeight: '2.8em',
            }}
          >
            <Link
              to={
                type === 'live'
                  ? all_routes.studentLiveEventDetails.replace(
                      ':id',
                      course.id.toString(),
                    )
                  : type === 'course'
                  ? all_routes.studentCourseContent.replace(
                      ':id',
                      course.id.toString(),
                    )
                  : type === 'cbt'
                  ? all_routes.jadiUkomDetail.replace(
                      ':id',
                      course.id.toString(),
                    )
                  : all_routes.courseDetails
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              {course.title}
            </Link>
          </h6>
          <div className="d-flex align-items-center">
            <div className="price">
              {course.discount && course.discount !== '0.00' ? (
                <h5>
                  {calculateDiscount(
                    parseFloat(course.price),
                    course.discount,
                    course.discount_type,
                  )}{' '}
                  <span>{rupiahFormatter(parseFloat(course.price))}</span>
                </h5>
              ) : (
                <h5>{rupiahFormatter(parseFloat(course.price))}</h5>
              )}
            </div>
          </div>
          <Link
            to={
              type === 'live'
                ? all_routes.studentLiveEventDetails.replace(
                    ':id',
                    course.id.toString(),
                  )
                : type === 'course'
                ? all_routes.studentCourseContent.replace(
                    ':id',
                    course.id.toString(),
                  )
                : type === 'cbt'
                ? all_routes.jadiUkomDetail.replace(':id', course.id.toString())
                : all_routes.courseDetails
            }
            className="btn btn-dark btn-sm d-inline-flex align-items-center mt-2 fit-content"
            style={{
              width: 'fit-content',
            }}
          >
            Lihat Detail
            <i className="isax isax-arrow-right-3 ms-1" />
          </Link>
        </div>
      </div>
    </div>
  )
}

const StudentCourse = () => {
  const [selectedItems, setSelectedItems] = useState<{
    [key: number]: boolean
  }>({})

  // Fetch purchased courses data
  const { data: purchasedCoursesData, isLoading, error } = useQuery({
    queryKey: ['purchasedCourses'],
    queryFn: getPurchasedCourses,
  })

  const handleItemClick = (index: number) => {
    setSelectedItems((prevSelectedItems) => ({
      ...prevSelectedItems,
      [index]: !prevSelectedItems[index],
    }))
  }

  // Loading state
  if (isLoading) {
    return (
      <>
        <Breadcrumb title="Enrolled Courses" />
        <div className="content">
          <div className="container">
            <ProfileCard />
            <div className="row">
              <StudentSidebar />
              <div className="col-lg-9">
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ minHeight: '400px' }}
                >
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

  // Error state
  if (error) {
    return (
      <>
        <Breadcrumb title="Enrolled Courses" />
        <div className="content">
          <div className="container">
            <ProfileCard />
            <div className="row">
              <StudentSidebar />
              <div className="col-lg-9">
                <div className="alert alert-danger" role="alert">
                  Failed to load purchased courses. Please try again later.
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

  const liveCourses = purchasedCoursesData?.data?.Live_Teaching || []
  const regularCourses = purchasedCoursesData?.data?.Course || []
  const cbtCourses = purchasedCoursesData?.data?.CBT || []

  return (
    <>
      <Breadcrumb title="Enrolled Courses" />

      <div className="content">
        <div className="container">
          {/* profile box */}
          <ProfileCard />
          {/* profile box */}
          <div className="row">
            {/* sidebar */}
            <StudentSidebar />
            {/* sidebar */}
            <div className="col-lg-9">
              <div className="page-title d-flex flex-wrap gap-3 align-items-center justify-content-between">
                <h5>Enrolled Courses</h5>
                <div className="tab-list">
                  <ul className="nav mb-0 gap-2" role="tablist">
                    <li className="nav-item mb-0" role="presentation">
                      <Link
                        to="#"
                        className="active"
                        data-bs-toggle="tab"
                        data-bs-target="#enroll-courses"
                        aria-selected="true"
                        role="tab"
                      >
                        Live ({liveCourses.length})
                      </Link>
                    </li>
                    <li className="nav-item mb-0" role="presentation">
                      <Link
                        to="#"
                        data-bs-toggle="tab"
                        data-bs-target="#active-courses"
                        aria-selected="false"
                        role="tab"
                        className=""
                        tabIndex={-1}
                      >
                        Course ({regularCourses.length})
                      </Link>
                    </li>
                    <li className="nav-item mb-0" role="presentation">
                      <Link
                        to="#"
                        data-bs-toggle="tab"
                        data-bs-target="#complete-courses"
                        aria-selected="false"
                        role="tab"
                        className=""
                        tabIndex={-1}
                      >
                        CBT ({cbtCourses.length})
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="tab-content">
                <div
                  className="tab-pane fade active show"
                  id="enroll-courses"
                  role="tabpanel"
                >
                  <div className="row">
                    {liveCourses.length > 0 ? (
                      liveCourses.map((course) => (
                        <CourseCard
                          key={course.id}
                          course={course}
                          selectedItems={selectedItems}
                          handleItemClick={handleItemClick}
                          type="live"
                        />
                      ))
                    ) : (
                      <div className="col-12">
                        <div className="text-center py-5">
                          <p className="text-muted">
                            No live courses enrolled yet.
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="active-courses"
                  role="tabpanel"
                >
                  <div className="row">
                    {regularCourses.length > 0 ? (
                      regularCourses.map((course) => (
                        <CourseCard
                          key={course.id}
                          course={course}
                          selectedItems={selectedItems}
                          handleItemClick={handleItemClick}
                          type="course"
                        />
                      ))
                    ) : (
                      <div className="col-12">
                        <div className="text-center py-5">
                          <p className="text-muted">No courses enrolled yet.</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="complete-courses"
                  role="tabpanel"
                >
                  <div className="row">
                    {cbtCourses.length > 0 ? (
                      cbtCourses.map((course) => (
                        <CourseCard
                          key={course.id}
                          course={course}
                          selectedItems={selectedItems}
                          handleItemClick={handleItemClick}
                          type="cbt"
                        />
                      ))
                    ) : (
                      <div className="col-12">
                        <div className="text-center py-5">
                          <p className="text-muted">
                            No CBT courses enrolled yet.
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* /pagination */}
              {/* <div className="row align-items-center mt-2">
                <div className="col-md-2">
                  <p className="pagination-text">Page 1 of 1</p>
                </div>
                <div className="col-md-10">
                  <ul className="pagination lms-page justify-content-center justify-content-md-end mt-2 mt-md-0">
                    <li className="page-item prev">
                      <Link className="page-link" to="#" tabIndex={-1}>
                        <i className="fas fa-angle-left" />
                      </Link>
                    </li>
                    <li className="page-item first-page active">
                      <Link className="page-link" to="#">
                        1
                      </Link>
                    </li>
                    <li className="page-item next">
                      <Link className="page-link" to="#">
                        <i className="fas fa-angle-right" />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div> */}
              {/* /pagination */}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default StudentCourse
